import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { SymbolPackDTO } from '@nora-monorepo/nora-api-client';
import { SymbolUsageEnum } from '@nora-monorepo/nora-api-client';
import { isNonEmptyString } from '@nora-monorepo/shared';

import type { SymbolOptions } from '#nora-ui/map/drawtools/symbol-tool/symbol-tool.types';
import { useSymbolStore } from '#nora-ui/stores/symbol-store';

function symbolToolStore() {
  const symbolStore = useSymbolStore();

  const selectedSymbol = ref<SymbolOptions | null>(null);
  const symbolPacks = ref<SymbolPackDTO[] | null>(null);

  const loadSymbolPacks = async (): Promise<void> => {
    symbolPacks.value = await symbolStore.getSymbolPacks(SymbolUsageEnum.MARKER);
  };

  const loadSymbolPack = async (packId: string): Promise<SymbolPackDTO | null> => {
    return await symbolStore.getSymbolPack(packId);
  };

  const setSelectedSymbol = (symbol: SymbolOptions | null): void => {
    selectedSymbol.value = symbol;
  };

  const reset = (): void => {
    selectedSymbol.value = null;
  };

  return {
    symbolPacks,
    selectedSymbol,

    setSelectedSymbol,
    loadSymbolPacks,
    loadSymbolPack,
    reset,
  };
}

export function useSymbolToolStore(storeId?: string | null) {
  if (!isNonEmptyString(storeId)) {
    return defineStore(`symbolToolStore`, symbolToolStore)();
  }

  return defineStore(`symbolToolStore-${storeId}`, symbolToolStore)();
}

export default useSymbolToolStore;
